import {Text} from "pixi.js";
import GraphicsButton from "./GraphicsButton.ts";
import ICreate from "../interfaces/ICreate.ts";
import IDestroy from "../interfaces/IDestroy.ts";
import AlignUtil from "../utils/AlignUtil.ts";
import RhColors from "../models/RhColors.ts";
import MarkText from "./MarkText.ts";

export default class InteractionDecodeIconButton extends GraphicsButton implements ICreate, IDestroy
{
    public fontFamily:string;
    public fontSize:number;
    public iconColor:string
    public iconColorDisabled:string
    public iconColorHover:string
    public iconColorPressed:string
    public iconString:string;
    public id:number;
    public placement:string;
    public targetTextField:MarkText;

    private iconField:Text;
    private iconFieldDisabled:Text;
    private iconFieldHover:Text;
    private iconFieldPressed:Text;

    constructor() {
        super();
        this._init();
    }

    private _init():void
    {
        this.fontFamily = "rhdicons";
        this.fontSize = 14;
        this.iconColor = RhColors.BTN_PRIMARY;
        this.iconColorHover = RhColors.WHITE;
        this.iconString = "";
    }

    private addListeners():void
    {
        this.onpointerout = (event) =>
        {
            super.pointerOut();
            this.iconFieldHover.visible = false;
            this.iconField.visible = true;
        }
        this.onpointerover = (event) =>
        {
            super.pointerOver();
            this.iconField.visible = false;
            this.iconFieldHover.visible = true;
        };
    }

    private createIcon():void
    {
        this.iconField = new Text({text:this.iconString, style:{fontFamily:this.fontFamily, fontSize:this.fontSize, fill:this.iconColor, align:AlignUtil.CENTER}});
        this.iconField.anchor.set(.5, .38);
        this.iconField.x = this.btnWidth / 2;
        this.iconField.y = this.btnHeight / 2;
        this.addChild(this.iconField);
    }

    private createIconHover():void
    {
        this.iconFieldHover = new Text({text:this.iconString, style:{fontFamily:this.fontFamily, fontSize:this.fontSize, fill:this.iconColorHover, align:AlignUtil.CENTER}});
        this.iconFieldHover.anchor.set(.5, .38);
        this.iconFieldHover.x = this.btnWidth / 2;
        this.iconFieldHover.y = this.btnHeight / 2;
        this.iconFieldHover.visible = false;
        this.addChild(this.iconFieldHover);
    }
    
    public create():void
    {
        super.create();
        this.createIcon();
        this.createIconHover();
    }
    
    public destroy():void
    {
        super.destroy();
    }

    public override disable():void
    {
        super.disable();
        this.iconField.visible = true;
        this.iconFieldHover.visible = false;
    }

    public override enable():void
    {
        super.enable();
    }

    public hide():void
    {
        this.visible = false;
    }
    
    public override pointerOut():void
    {
        super.pointerOut();
        this.iconFieldHover.visible = false;
        this.iconField.visible = true;
    }

    public override pointerOver():void
    {
        super.pointerOver();
        this.iconField.visible = false;
        this.iconFieldHover.visible = true;
    }
    
    public reset():void
    {
        this.pointerOut();
    }
    
}